/**
 * Ryan O'Dowd
 * 2025-06-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode, fonts}) => {
  const containerAndLabelAttrs = { // @TODO: abstract with FormLabel
    backgroundColor: isDarkMode ? colors.completeBg : colors.white,
    borderWidth: 3,
    borderColor: isDarkMode ? colors.gray : colors.lightGray,
    borderTopLeftRadius: globalScale * 12,
    borderTopRightRadius: globalScale * 12,
    borderBottomRightRadius: globalScale * 12,
    borderBottomLeftRadius: globalScale * 12,
  };

  return {
    outerContainer: (isDisabled) => {
      return {
        display: 'flex',
        flexGrow: 1,
        flexShrink: 1,
        marginTop: globalScale * 14, // @NOTE: to match (and exceed) top of FormLabel so that it's not cut off
        opacity: isDisabled ? 0.5 : 1,
      };
    },
    container: {
      fontFamily: fonts.primary,
      backgroundColor: '#00000000',
    },
    outlinedContainer: {
      flexDirection: 'row',
      textAlign: 'left',
      fontSize: globalScale * 16,
      ...containerAndLabelAttrs,
    },
    outlinedContainerAlert: {
      borderColor: colors.alert,
    },
    addPadding: {
      padding: globalScale * 8,
    },
  };
};

export default getStyles;
